<template>
  <div class="row">
    <div class="col-12">
      <input-select-search
        ref="produto"
        v-model="form.produtoId"
        :label="$t('SUPRIMENTOS.SELECIONAR_PRODUTO')"
        :options="opcoes.produtos"
        @input="buscaQuantidadeSistema"
        required
      />
    </div>
    <div class="col-12">
      <input-select-search
        ref="deposito"
        v-model="form.depositoId"
        :label="$t('SUPRIMENTOS.SELECIONAR_DEPOSITO')"
        :options="opcoes.depositos"
        @input="buscaQuantidadeSistema"
        required
      />
    </div>
    <div class="col-6">
      <input-text
        ref="quantidadeSistema"
        v-model="form.quantidadeSistema"
        type="number"
        :label="$t('SUPRIMENTOS_ESTOQUE.QUANTIDADE_SISTEMA')"
        disabled
      />
    </div>
    <div class="col-6">
      <input-text
        ref="quantidadeContada"
        v-model="form.quantidadeContada"
        type="number"
        :label="$t('SUPRIMENTOS_ESTOQUE.QUANTIDADE_CONTADA')"
        :placeholder="$t('GERAL.SOMENTE_NUMEROS')"
        :min="0"
        required
      />
    </div>
    <div class="col-6">
      <input-text
        ref="diferenca"
        :value="diferencaFormatada"
        type="text"
        :label="$t('SUPRIMENTOS_ESTOQUE.DIFERENCA_INVENTARIO')"
        disabled
      />
    </div>
    <div class="col-6">
      <input-date-only-btn
        ref="dataMovimento"
        v-model="form.dataMovimento"
        :label="$t('SUPRIMENTOS_ESTOQUE.DATA_AJUSTE')"
        required
      />
    </div>
    <div v-if="exigeValorUnitario" class="col-12">
      <b-alert variant="warning" show class="mb-2">
        {{ $t('SUPRIMENTOS_ESTOQUE.AJUSTE_INVENTARIO_AVISO_SEM_CUSTO') }}
      </b-alert>
      <input-text
        ref="valorUnitario"
        v-model="form.valorUnitario"
        type="number"
        :label="$t('SUPRIMENTOS_ESTOQUE.VALOR_UNITARIO_SOBRA')"
        :min="0"
        required
      />
    </div>
    <div class="col-12">
      <input-text
        ref="motivo"
        v-model="form.motivo"
        :label="$t('SUPRIMENTOS_ESTOQUE.MOTIVO_AJUSTE')"
        :placeholder="$t('SUPRIMENTOS.DESCRICAO')"
        type="text"
        :minLength="1"
        :maxLength="70"
        required
      />
    </div>
  </div>
</template>
<script>
import {
  InputText,
  InputSelectSearch,
  InputDateOnlyBtn,
} from '@/components/inputs';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import EstoqueService from '@/common/services/estoque/estoque.service';

export default {
  props: {
    form: { type: Object, default: Object },
    opcoes: {
      type: Object,
      default: () => ({
        depositos: [],
        produtos: [],
      }),
    },
  },
  components: {
    InputText,
    InputSelectSearch,
    InputDateOnlyBtn,
  },
  computed: {
    diferenca() {
      if (this.form.quantidadeContada === null || this.form.quantidadeContada === '') return null;
      return Number(this.form.quantidadeContada) - Number(this.form.quantidadeSistema || 0);
    },
    diferencaFormatada() {
      if (this.diferenca === null) return '';
      return this.diferenca > 0 ? `+${this.diferenca}` : `${this.diferenca}`;
    },
    // Sobra de um produto zerado no depósito: não há custo médio, então o valor unitário é obrigatório.
    exigeValorUnitario() {
      return this.diferenca > 0 && !Number(this.form.quantidadeSistema || 0);
    },
  },
  mounted() {
    this.$emit('refs', this.$refs);
  },
  watch: {
    exigeValorUnitario() {
      this.$nextTick(() => this.$emit('refs', this.$refs));
    },
  },
  methods: {
    async buscaQuantidadeSistema() {
      if (!this.form.produtoId || !this.form.depositoId) return;
      this.$store.dispatch(START_LOADING);
      await EstoqueService.buscaSaldoTotalProduto({
        produtoId: this.form.produtoId,
        depositoId: this.form.depositoId,
      })
        .then(({ data }) => {
          this.form.quantidadeSistema = data || 0;
        })
        .catch(() => {
          // Produto ainda sem estoque neste depósito: o ajuste pode criar o estoque (sobra).
          this.form.quantidadeSistema = 0;
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>
